module.exports = __webpack_public_path__ + "img/蒙版组 605@2x.1ce1a49c.png";